// React
import { useState, useEffect } from "react";

// Material UI
import { Button, FormHelperText, Stack } from "@mui/material";
import { MuiOtpInput } from "mui-one-time-password-input";
import { Close, Autorenew } from "@mui/icons-material";

// Styles
import { styles } from "./styles";
import { useTranslation } from "react-i18next";

export const OTP = ({
  setCode,
  resendCode,
  values,
  handleChange,
  errors,
  touched,
}) => {
  const { t } = useTranslation();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 400);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 400);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleClearCode = () => {
    setCode("code", "");
  };

  const handleKeyDown = (e, values, handleChange) => {
    if (
      e.key === "Backspace" &&
      currentIndex >= 0 &&
      currentIndex < values.code.length &&
      values.code[currentIndex] !== ""
    ) {
      e.preventDefault();
      const updatedCode = values.code.split("");
      updatedCode[currentIndex] = "";
      handleChange(updatedCode.join(""));
    }
  };

  return (
    <Stack sx={styles.otpBox}>
      <MuiOtpInput
        value={values.code}
        onChange={handleChange}
        onKeyDown={(e) => handleKeyDown(e, values, handleChange)}
        length={6}
        autoFocus
        validateChar={(value) => /^[0-9]$/.test(value)}
        TextFieldsProps={(index) => ({
          type: "tel",
          inputMode: "numeric",
          pattern: "[0-9]*",
          size: isMobile ? "small" : "medium",
          onFocus: () => setCurrentIndex(index),
        })}
        sx={styles.otpInput}
      />
      {touched.code && Boolean(errors.code) && (
        <FormHelperText error id="otp-error-text" sx={{ textAlign: "center" }}>
          {errors.code}
        </FormHelperText>
      )}
      <Stack sx={styles.otpButtonsBox}>
        <Button
          type="button"
          variant="text"
          onClick={handleClearCode}
          startIcon={<Close color="primary" />}
        >
          {t(isMobile ? "otp.clear" : "otp.clearCode")}
        </Button>
        <Button
          type="button"
          variant="outlined"
          onClick={resendCode}
          startIcon={<Autorenew color="primary" />}
          sx={{ backgroundColor: "transparent" }}
        >
          {t(isMobile ? "otp.resend" : "otp.resendCode")}
        </Button>
      </Stack>
    </Stack>
  );
};
